module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticStyle: {
      "display": "flex"
    }
  }, [_c('my-map', {
    staticClass: "my-map",
    attrs: {
      "markers": _vm.markers,
      "tutors": _vm.maptutors
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6cd0df83"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Pages/Tutor/TutorMap.vue
// module id = 1404
// module chunks = 0